import { create } from 'zustand';

export type ObjectType = 'default' | 'sky' | 'sun' | 'mountain' | 'person' | 'face' | 'title';

export type Scene = {
  id: number;
  name: string;
  duration: string;
  icon: string;
  aiBadge?: boolean;
};

export type EditorState = {
  selectedObject: ObjectType;
  activeSceneId: number;
  scenes: Scene[];
  cmdKOpen: boolean;
  generateOpen: boolean;
  toast: string | null;
  aiAnalyzing: boolean;
  setSelectedObject: (obj: ObjectType) => void;
  setActiveSceneId: (id: number) => void;
  openCmdK: () => void;
  closeCmdK: () => void;
  openGenerate: () => void;
  closeGenerate: () => void;
  setToast: (msg: string | null) => void;
  setAiAnalyzing: (v: boolean) => void;
};

const initialScenes: Scene[] = [
  { id: 1, name: 'Intro', duration: '0:06', icon: 'sunrise' },
  { id: 2, name: 'Person / soluppgang', duration: '0:12', icon: 'user' },
  { id: 3, name: 'Landskap', duration: '0:08', icon: 'mountain-snow' },
  { id: 4, name: 'Dialog', duration: '0:15', icon: 'message-circle' },
  { id: 5, name: 'Titel', duration: '0:04', icon: 'type' },
  { id: 6, name: 'AI-outro', duration: '0:13', icon: 'wand-2', aiBadge: true },
];

export const useEditor = create<EditorState>((set) => ({
  selectedObject: 'default',
  activeSceneId: 2,
  scenes: initialScenes,
  cmdKOpen: false,
  generateOpen: false,
  toast: null,
  aiAnalyzing: true,
  setSelectedObject: (obj) => set({ selectedObject: obj }),
  setActiveSceneId: (id) => set({ activeSceneId: id }),
  openCmdK: () => set({ cmdKOpen: true }),
  closeCmdK: () => set({ cmdKOpen: false }),
  openGenerate: () => set({ generateOpen: true }),
  closeGenerate: () => set({ generateOpen: false }),
  setToast: (msg) => set({ toast: msg }),
  setAiAnalyzing: (v) => set({ aiAnalyzing: v }),
}));
